<template>
  <div class="page-home">
    <Scroll ref="myScroll" :loading-text="mReachText" :height="mScrollHeight"
            :on-reach-top="handleRefresh"
            :on-reach-bottom="handleFeed"
            :distance-to-edge="0">
      <Swiper v-if="mBannerList && mBannerList.length>0" class="banner"
              :options="bannerOption" ref="banner"
              :slides-per-view="3" :space-between="50">
        <SwiperSlide v-for="(item,index) in mBannerList" :key="index"
                      class="banner-item">
          <img class="banner-img" :src="bannerImage(item)"/>
        </SwiperSlide>
        <div class="swiper-pagination" slot="pagination"></div>
        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
      </Swiper>
      <div v-else-if="mBannerList" class="no-banner"><p>Banner</p></div>

      <div class="title">{{$t('goods.group_all')}}</div>

      <div v-if="!mGoodsList"
           class="no-content-tip">{{$t('common.tip_loading')}}</div>
      <div v-else-if="mGoodsList.length > 0"
           style="padding: 0 20px">
        <Row type="flex" :gutter="20">
          <Col v-for="(goods, i) in mGoodsList" :key="i" :xs="12" :sm="8" :md="6" :lg="4">
            <MyGoods
              :value="goods"
              @on-buy="goOrderAdd(goods)"
              @on-detail="goGoodsDetail(goods)"/>
          </Col>
        </Row>
      </div>
      <div v-else class="no-content-tip">{{$t('goods.tip_no_items')}}</div>
    </Scroll>
  </div>
</template>
<script>
    import { httpGet, httpGetParams, CancelToken } from '@/api/http';
    import MyGoods from '@/components/MyGoodsNew';
    import 'swiper/css/swiper.css';
    import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
    import common from '../mixins/common';

    export default {
        components: {
            MyGoods,
            Swiper,
            SwiperSlide
        },
        mixins: [common],
        data () {
            return {
                mBannerList: null,

                mPage: 1,
                mTotal: 0,
                goods_class: '',

                mReachText: null,
                mScrollHeight: 300,
                mGoodsList: null,

                form: {
                    page: 1,
                    pageSize: 18
                },
                bannerOption: {
                    loop: true,
                    autoplay: {
                        delay: 3000,
                        stopOnLastSlide: false,
                        disableOnInteraction: false
                    },
                    // 显示分页
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true // 允许分页点击跳转
                    },
                    // 设置点击箭头
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev'
                    },
                    on: {
                        click: () => {
                            const index = this.$refs.banner.$swiper.realIndex;
                            this.bannerJump(this.mBannerList[index]);
                        }
                    }
                },
                mBannerRefreshTime: 0
            }
        },
        methods: {
            bannerImage (item) {
                if (typeof item === 'string') {
                    return item;
                }
                return item.image;
            },
            bannerJump (item) {
                if (!item.url) {
                    return;
                }
                if (item.url.type === 'url') {
                    window.location.href = item.url.value;
                } else if (item.url.type === 'goods') {
                    const id = parseInt(item.url.value);
                    if (isNaN(id)) {
                        this.$router.face.goodsSearch(item.url.value);
                    } else {
                        this.$router.face.goodsDetail(id);
                    }
                }
            },
            loadBanner () {
                httpGet('/v1/banners', null, { ignores: [] }).then(res => {
                    this.mBannerList = res;
                    const banner = this.$refs.banner.$swiper;
                    if (this.mBannerList.length <= 1) {
                        banner.autoplay.stop();
                    }
                }).catch(() => {
                }).finally(() => {
                    this.mBannerRefreshTime = new Date().getTime();
                });
            },
            loadData (more, resolve) {
                this.form.page = 0;
                if (more) {
                    this.form.page = this.mPage + 1;
                }
                if (this.$route.query.key) {
                    this.form.name = this.$route.query.key;
                }

                if (!resolve) {
                    this.$Spin.show();
                }
                this.loading = true;
                if (this.cancel) {
                    this.cancel();
                    this.cancel = null;
                }
                httpGetParams('/v1/goods', this.form, new CancelToken((c) => {
                    this.cancel = c;
                })).then(res => {
                    if (res.current_page) {
                        this.mPage = res.current_page;
                    } else {
                        this.mPage = this.form.page;
                    }
                    this.mTotal = res.total;
                    if (more && this.mGoodsList) {
                        this.mGoodsList = this.mGoodsList.concat(res.data);
                    } else {
                        this.mGoodsList = res.data;
                    }
                }).catch(() => {
                }).finally(() => {
                    if (!this.mGoodsList) {
                        this.mGoodsList = [];
                    }
                    if (this.cancel) {
                        this.cancel = null;
                    }

                    this.loading = false;
                    if (resolve) {
                        resolve();
                    } else {
                        this.$Spin.hide();
                    }
                });
            },
            handleRefresh () {
                if (this.loading) {
                    return;
                }
                if (this.mBannerRefreshTime + 5 * 60 * 1000 < new Date().getTime()) {
                    this.loadBanner();
                }
                this.mReachText = this.$t('common.tip_refresh');
                return new Promise(resolve => {
                    setTimeout(() => {
                        this.loadData(false, resolve);
                    }, 2000);
                });
            },
            handleFeed () {
                if (this.loading) {
                    return;
                }
                if (this.mTotal < this.form.pageSize) {
                    return this.handleRefresh();
                }
                this.mReachText = this.$t('common.tip_loadmore');
                return new Promise(resolve => {
                    setTimeout(() => {
                        this.loadData(true, resolve);
                    }, 2000);
                });
            },
            goGoodsDetail (goods) {
                this.$router.face.goodsDetail(goods);
            },
            goOrderAdd (goods) {
                this.$router.face.order(goods).go();
            }
        },
        created () {
            this.loadBanner();
            if (window.screen.width < 500) {
                this.goods_class += 'goods-min-layout'
            } else if (window.screen.width < 750) {
                this.goods_class += 'goods-med-layout'
            }
            const pageSize = Math.ceil(window.screen.width / 200) *
                Math.ceil(window.screen.height / 200);
            this.form.pageSize = pageSize < 10 ? 10 : pageSize;
            this.loadData();
        },
        beforeDestroy () {
            if (this.cancel) {
                this.cancel();
                this.cancel = null;
            }
        }
    }
</script>

<style lang="scss">
  .page-home {
    .ivu-scroll-loader-wrapper {
      padding: 0;
    }
    .no-banner {
      background-color: #428dfb;
      text-align: center;
      min-height: 130px;
      height: 25vh;
      color: white;
      font-weight: bold;
      font-size: 48px;
      >p {
        line-height: 200%;
        vertical-align: middle;
      }
    }
    .banner {
      &-item {
        text-align: center;
        padding: 0;
      }

      &-img {
        width: 100%;
        height: calc(100vw*1/4);//auto
        //max-height: 20vh;
        //min-height: 130px;
      }
    }

    .swiper-pagination-bullet-active {
      background-color: #707070;
    }
    .swiper-button-prev, .swiper-button-next {
      &:after {
        font-size: 24px;
        color: #c6c6c6;
      }
    }
  }
</style>
